//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {dateFormatter} from '@nuskin/ns-util';
import {ProductStatus} from '../services/productStatus';
export default {
  name: 'VariantSelector',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    /**
     * List of variants ([{ availableQuantity, sku, slug, variantLabel, variantSlug, variantColor? }])
     */
    variants: {
      type: Array,
      default: () => []
    },
    /**
     * The selected sku
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * A string specifying a name for the input control.
     */
    name: {
      type: String,
      default: 'variant'
    },
    /**
     * The pathname for the product detail page
     */
    pathname: {
      type: String,
      default: ''
    },
    /**
     * A custom label for the selector
     */
    selectLabel: {
      type: String,
      default: ''
    },
    /**
     * If the variant selector is using a bundle variant or not, to handle differences in eventing
     */
    isBundle: {
      type: Boolean,
      default: false
    },
    isOptional: {
      type: Boolean,
      default: false
    },
    optionalIsSelected: {
      type: Boolean,
      default: true
    },
    discontinuedProduct: {
      type: Boolean,
      default: false
    },
    replaceProdcuctPrice: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      changeSku: this.value,
      oldSku: this.value,
      replacementProductPrice: this.replaceProdcuctPrice
    };
  },
  computed: {
    selectedLabel() {
      return (
        (this.variants.find(({sku}) => sku === this.value) || {})
          .variantLabel || ''
      ).toUpperCase();
    },
    hasColors() {
      return this.variants.some(({variantColor}) => !!variantColor);
    },
    optionSelectStatus() {
      return this.optionalIsSelected;
    },
    traditionalLocale() {
      return this.$store.getters['nuskin/traditionalLocale'] || '';
    }
  },
  watch: {
    changeSku(oldSku, newSku) {
      this.oldSku = oldSku;
    }
  },
  methods: {
    getVariantUrl(slug) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', slug);
      return `${this.pathname}${currentUrl.search}`;
    },
    handleChange(event) {
      this.$emit('change', event.target.value);
    },
    handleBundleChange(event) {
      const selectedVariant = this.variants.find(
        (variant) => variant.sku === event.target.value
      );
      const Event = {
        event: 'MultiVariant',
        ecommerce: {
          detail: {
            products: [
              {
                variant_type:
                  selectedVariant?.variantLabel?.toLowerCase() || '',
                name: selectedVariant?.title || '',
                id: selectedVariant?.sku || '',
                price:
                  selectedVariant?.price?.retail ||
                  this.replacementProductPrice,
                replacement_product: selectedVariant?.discontinuedSkuReplacement
                  ? 'available'
                  : 'not available'
              }
            ]
          }
        },
        platform: 'Legacy'
      };

      this.$store.commit('nuskin/pushGoogleAnalyticsEvent', Event);

      if (this.isBundle) {
        event.preventDefault(); // so PDP doesn't reload on bundle variant initial click
        // so the styling and everything still updates in the VariantSelector.vue like it should
        this.changeSku = event.target.value;
        this.$emit('change', event.target.value);
        // pass the updated variant information so we can easily use it in the parent BundleProduct.vue
        this.$emit('new-bundle-variant-selected', {
          updatedVariant: JSON.parse(
            event.target.attributes.getNamedItem('variant-option').value
          ),
          oldSku: this.oldSku
        });
      } else {
        // non-bundle variant selector functionality from click
        this.changeSku = event.target.value;
        this.$emit('change', event.target.value);
      }
    },
    statusKey(variant) {
      const statusKey = 'status';
      const status = (variant.status || {})[statusKey];
      if (status === ProductStatus.Sellable) {
        if ((variant.status || {}).inventory === 'backordered') {
          return 'onBackorder';
        }
        if ((variant.status || {}).inventory === 'outOfStock') {
          return 'outOfStock';
        }
        if (variant.isExclusive && variant.atpQuantity === 0) {
          return 'reachedPurchaseLimit';
        }
      } else if (status === ProductStatus.Discontinued) {
        return 'discontinued';
      } else if (status === ProductStatus.Inactive) {
        return 'notReleasedForSale';
      } else if (status === ProductStatus.Stopped) {
        return 'stopStatus';
      } else if (status === ProductStatus.BundleOnly) {
        return 'notSoldSeperately';
      }
      return 'releasedForSale';
    },
    statusMessage(option) {
      const statusKey = this.statusKey(option);
      const backorderDate = option.backorderedAvailableDate;
      switch (statusKey) {
        case 'onBackorder':
          return this.$t('status.onBackorder').replace(
            '%date%',
            dateFormatter.getCountryFormattedDate(
              backorderDate,
              this.traditionalLocale
            )
          );
        case 'reachedPurchaseLimit':
          return this.$t('status.reachedPurchaseLimit');
        case 'outOfStock':
          return this.$t('status.outOfStock');
        case 'discontinued':
          return this.$t('status.discontinued');
        case 'notReleasedForSale':
          return this.$t('status.notReleasedForSale');
        case 'stopStatus':
          return this.$t('status.stopStatus');
        case 'notSoldSeperately':
          return this.$t('status.notSoldSeperately');
        default:
          return '';
      }
    }
  }
};
